/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum MaterialEducationalAliases {
  CARD_MATERIAL_EDUCATION_MATERIAL_MATERIAL_EDUCATION = 'card-material-education-material-material-education',
  MATERIAL_CONTEXTUAL_BAR = 'material-contextual-bar',
  MATERIAL_FETCH = 'material-fetch',
  MATERIAL_LAYOUT = 'material-layout',
  MATERIAL_PANEL = 'material-panel',
  MATERIAL_SEGMENTED_CONTROL = 'material-segmented-control',
}
export { MaterialEducationalAliases };
